import type { ComponentType } from 'react';

type DRBadgeColor = 'amber' | 'green' | 'red';

/** Shared pill badge used across DR settings and proposal dialogs. */
export function DRBadge({
  icon: Icon,
  label,
  color,
}: {
  icon: ComponentType<{ className?: string }>;
  label: string;
  color: DRBadgeColor;
}) {
  const cls =
    color === 'amber'
      ? 'bg-orange-100 text-orange-900'
      : color === 'green'
        ? 'bg-emerald-100 text-emerald-900'
        : 'bg-red-100 text-red-800';
  return (
    <span
      className={`inline-flex items-center gap-1 ${cls} text-xs font-medium px-2.5 py-1 rounded-md border border-white`}
    >
      <Icon className="w-3.5 h-3.5" />
      {label}
    </span>
  );
}
